import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../services/firebase"; // Pastikan import betul


const StudentDashboard = () => {
    const [user, setUser] = useState(null);
    const [studentData, setStudentData] = useState(null);
    const [schoolName, setSchoolName] = useState("-");
    const [classroomName, setClassroomName] = useState("-");



    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        setUser(storedUser);

        const fetchStudentData = async () => {
            if (!storedUser) return;

            const studentRef = doc(db, "students", storedUser.id);
            const studentSnap = await getDoc(studentRef);

            if (studentSnap.exists()) {
                const data = studentSnap.data();
                setStudentData(data);

            }
        };

        fetchStudentData();
    }, []);

    useEffect(() => {
        const fetchSchoolAndClassName = async () => {
            if (!user?.schoolId || !user?.classroomId) return;

            try {
                // Fetch school name
                const schoolRef = doc(db, "schools", user.schoolId);
                const schoolSnap = await getDoc(schoolRef);
                if (schoolSnap.exists()) {
                    setSchoolName(schoolSnap.data().name || "-");
                }

                // Fetch classroom name
                const classroomRef = doc(db, "schools", user.schoolId, "classrooms", user.classroomId);
                const classroomSnap = await getDoc(classroomRef);
                if (classroomSnap.exists()) {
                    setClassroomName(classroomSnap.data().name || "-");
                }
            } catch (err) {
                console.error("❌ Error fetching school/classroom name:", err);
            }
        };

        fetchSchoolAndClassName();
    }, [user?.schoolId, user?.classroomId]);



    const formatDate = (timestamp) => {
        if (!timestamp?.toDate) return "-";
        const date = timestamp.toDate();
        return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
    };


    if (!user || !studentData) {
        return <p style={{ color: "red" }}>No user data found.</p>;
    }

    return (
        <div className="dashboard-container">

            <div className="student-profile">
                <div className="profile-item"><span>Sekolah:</span> {schoolName}</div>
                <div className="profile-item"><span>Kelas:</span> {classroomName}</div>
                <div className="profile-item"><span>Email:</span> {studentData.email}</div>
                <div className="profile-item"><span>Tarikh Sertai:</span> {formatDate(studentData.createdAt)}</div>
            </div>

            <div className="statistik">
                <div className="stat-grid">
                    <div className="stat-card">
                        <p className="stat-label">Jumlah Bacaan</p>
                        <p className="stat-value">{studentData.progress?.length || 0} kali</p>
                    </div>
                    <div className="stat-card">
                        <p className="stat-label">Jumlah Hari</p>
                        <p className="stat-value">
                            {(() => {
                                const dates = studentData.progress?.map(p => p.date);
                                const uniqueDates = new Set(dates);
                                return `${uniqueDates.size || 0} hari`;
                            })()}
                        </p>
                    </div>

                    <div className="stat-card">
                        <p className="stat-label">Surah Terkini</p>
                        <p className="stat-value">
                            {studentData.progress?.at(-1)?.surah || "Tiada"}
                        </p>
                    </div>
                    <div className="stat-card">
                        <p className="stat-label">Tarikh Akhir</p>
                        <p className="stat-value">
                            {studentData.progress?.at(-1)?.date || "Tiada"}
                        </p>
                    </div>
                    <div className="stat-card">
                        <p className="stat-label">Hari Tidak Membaca</p>
                        <p className="stat-value">
                            {(() => {
                                const lastDate = studentData.progress?.at(-1)?.date;
                                if (!lastDate) return "-";

                                const [day, month, year] = lastDate.split("/");
                                const last = new Date(`${year}-${month}-${day}`);
                                const now = new Date();
                                const diffDays = Math.floor((now - last) / (1000 * 60 * 60 * 24));
                                return `${diffDays} hari`;
                            })()}
                        </p>
                    </div>
                    <div className="stat-card">
                        <p className="stat-label">Peratus Bacaan</p>
                        <p className="stat-value">
                            {(() => {
                                const totalAyahRead = studentData.progress?.reduce((total, p) => total + (p.endAyah - p.startAyah + 1), 0) || 0;
                                const percentage = ((totalAyahRead / 6236) * 100).toFixed(1);
                                return `${percentage}%`;
                            })()}
                        </p>
                    </div>
                </div>
            </div>


            <div className="table-responsive">
                <table className="progress-table">
                    <thead>
                        <tr>
                            <th>Tarikh</th>
                            <th>Masa</th>

                            <th>Surah</th>
                            <th>Ayat</th>
                            <th>Guru</th>

                            <th>Ulasan</th>
                        </tr>
                    </thead>
                    <tbody>
                        {studentData.progress?.map((item, index) => (
                            <tr key={index}>
                                <td data-label="Tarikh">{item.date}</td>
                                <td data-label="Masa">{item.time}</td>

                                <td data-label="Surah">{item.surah}</td>
                                <td data-label="Ayat">{item.startAyah} - {item.endAyah}</td>
                                <td data-label="Guru">{item.guru || "Guru"}</td>

                                <td data-label="Ulasan">{item.ulasan}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>


    );
};

export default StudentDashboard;
